// extracted by mini-css-extract-plugin
module.exports = {"root":"TldrBlock__root___3W8sW","referenceNumberSection":"TldrBlock__referenceNumberSection___2oyEo","textSection":"TldrBlock__textSection___2xfqm"};